module.exports = __webpack_public_path__ + "media/parents/preparing-academically-d668d691.svg";